import type { FC } from 'react';
import React from 'react';
import { useRouter } from 'next/router';

import { EosNavigation } from '@wf-components/navigation-react';
import { useUserContext } from '@contexts/User';
import type { PublicSettingsDto } from '@dto/PublicSettings.dto';
import { getSignOutLink, getSignInLink } from '@utils/header';
import { setCookieLocaleHandler } from '@wf-components/navigation-consumer';
import { useLocale } from '@contexts/Locale';

export interface HeaderProps {
  publicRuntimeSettings: Pick<
    PublicSettingsDto,
    'epicServiceClientId' | 'epicAccountPortalBaseUrl' | 'epicAccountPortalBasePath'
  >;
}

export const Header: FC<HeaderProps> = (props): JSX.Element => {
  const router = useRouter();
  const account = useUserContext();
  const locale = useLocale();

  let currentPath = `${router.basePath}${router.asPath === '/' ? '' : router.asPath}`;
  if (currentPath.includes('AccessDeniedPage')) {
    const pathArray = currentPath.split('?resolvedUrl=');
    if (pathArray.length > 1) {
      currentPath = `${pathArray[1]}`;
    }
  }
  const loginLink: string = getSignInLink(props.publicRuntimeSettings, currentPath);
  const signOutLink: string = getSignOutLink(props.publicRuntimeSettings, currentPath);

  const handleNavLocaleClick = (e) => {
    e.detail.originalEvent.preventDefault();
    window.localStorage.setItem('activeTags', '[]');
    setCookieLocaleHandler(e, { cookieSecure: window.location.hostname !== 'localhost' });
  };

  return (
    <EosNavigation
      disableSearch
      locale={locale}
      isLoggedIn={account?.isLoggedIn}
      displayName={account?.displayName}
      localeOnClick={handleNavLocaleClick}
      signInLinkHref={loginLink}
      signOutLinkHref={signOutLink}
      // @ts-ignore
      sticky={false}
    />
  );
};
